import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PropertyMapss from "./PropertyMaps";
import httpCommon from "../../http-common";
import Container from "../../component/Container";
import AdvancedSearch from "../../component/searchBar/AdvancedSearch";
import Card from "../../component/card/card";
import Social from "../../component/Social";
import { FaSellsy } from "react-icons/fa6";
import { MdAddHome } from "react-icons/md";
import { IoMdHappy } from "react-icons/io";
import { FaRegHandshake } from "react-icons/fa";
import { FaWhatsapp } from 'react-icons/fa';
import Loader from "../../component/Loader/Loader";

function PropertyQuery() {
    const [allProperties, setAllProperties] = useState([]);
    const center = { lat: 12.9716, lng: 77.5946 };
    const [originalProperties, setOriginalProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedProperties, setSelectedProperties] = useState([]);


    const location = useLocation();
    const query = location.state?.query || "";
    const query2 = location.state?.data || "";

  //  console.log("filterParams____query",query2);

  // Function to handle new search from AdvancedSearch component
    const handleAdvanceSearch = (data) => {
        console.log("Advanced Search Data from Property page:", data);
        // Update the filtering with new search data
        fetchAllProperties({}, data);
    };

 const convertBudgetStringToNumber = (str) => {
  if (!str) return 0;

  // If the value is already a number, return as-is in rupees
  if (typeof str === 'number') return str * 100000; // Assuming number is in LAC

  const [amount, unit] = str.toUpperCase().split(" ");
  const num = parseFloat(amount);

  if (unit === "LAC" || unit === "LACS") return num * 100000;
  if (unit === "CR" || unit === "CRS") return num * 10000000;

  return num; // fallback
};

    const fetchAllProperties = async (filterParams = {}, searchData = null) => {
        setLoading(true);
        setError(null);
       // console.log("filterParams____",filterParams);
        try {
            const response = await httpCommon.get(`/list`, {
                params: filterParams
            });
           // console.log("filterParams____res",response);

            if (response.data.status === "success") {
                const properties = response.data.data;
              //  console.log("properties___",properties);
                let filteredProperties = properties;
console.log("filteredProperties____",filteredProperties);
                const filterData = searchData || location.state?.data || {};
              //  console.log("filterData___console",filterData);
               
                const minBudget = convertBudgetStringToNumber(filterData.minBudget);
                const maxBudget = convertBudgetStringToNumber(filterData.maxBudget);

                const locations = filterData.location || [];
                const propertyTypes = filterData.propertyType || [];
                const projectTitles = filterData.projectTitle || [];

             
                const parsePrice = (priceStr) =>
                Number(priceStr?.replace(/[^\d.]/g, '')) || 0;

                filteredProperties = properties.filter((property) => {
                const price = parsePrice(property.ltg_det_sale_price);

                const matchesLocation =
                    !locations.length ||
                    locations.some((loc) =>
                     property.ltg_title?.toLowerCase().includes(loc.toLowerCase().trim())
                    );

                const matchesType =
                    !propertyTypes.length ||
                    propertyTypes.some((type) =>
                    property.ltg_type?.toLowerCase().trim() === type.toLowerCase().trim()
                    );

                const matchesBudget =
                    (!minBudget || price >= minBudget) &&
                    (!maxBudget || price <= maxBudget);

                //     const matchesProjectTitle =
                //         !projectTitles.length ||
                //         projectTitles.some((title) =>
                //         property.ltg_projectName?.toLowerCase().trim() === title.toLowerCase().trim()
                //         );

                // return matchesLocation && matchesType && matchesBudget && matchesProjectTitle;

                  // ⭐ UPGRADED MULTI-KEYWORD PROJECT TITLE MATCH ⭐
                    const matchesProjectTitle =
                        !projectTitles.length ||
                        projectTitles.some((title) => {
                        // convert user input into keywords: e.g. "golden whitefield"
                        const keywords = title.toLowerCase().trim().split(/\s+/);

                        const projectName = property.ltg_projectName?.toLowerCase() || "";
                        const fullTitle = property.ltg_title?.toLowerCase() || "";

                        const combinedText = projectName + " " + fullTitle;

                        // all keywords must match somewhere in combined text
                        return keywords.every((word) => combinedText.includes(word));
                        });

                    return (
                        matchesLocation &&
                        matchesType &&
                        matchesBudget &&
                        matchesProjectTitle
                    );

                

                }).sort((a, b) => {
                    // First: sort sold_type = 0 first, then sold_type = 1
                    if (a.ltg_det_sold_type !== b.ltg_det_sold_type) {
                    return a.ltg_det_sold_type - b.ltg_det_sold_type; // 0 before 1
                    }

                    // Second: within same sold_type, sort by date DESC (latest first)
                    return new Date(b.ltg_create_date) - new Date(a.ltg_create_date);
                });


               console.log("filteredProperties___query list",filteredProperties);
               
                setAllProperties(filteredProperties);
                setOriginalProperties(properties);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setError("Failed to fetch properties. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    // Handle filter changes
    const handleFilterChange = (formData = {}) => {
        if (!formData || Object.keys(formData).length === 0) {
            setAllProperties(originalProperties);
            return;
        }

        let filteredProperties = originalProperties || [];

        if (filteredProperties.length === 0) {
            setAllProperties(filteredProperties);
            return;
        }

        if (formData.search) {
            filteredProperties = filteredProperties.filter((item) =>
                item.ltg_regions?.toLowerCase().includes(formData.search.toLowerCase()) ||
                item.ltg_categories?.toLowerCase().includes(formData.search.toLowerCase())
            );
        }

        if (formData.city && formData.city !== 'any') {
            filteredProperties = filteredProperties.filter((item) => {
                return item.ltg_regions?.toLowerCase() === formData.city.toLowerCase();
            });
        }

        if (formData.type && formData.type !== 'any') {
            filteredProperties = filteredProperties.filter((item) => {
                return item.ltg_categories?.toLowerCase() === formData.type?.toLowerCase();
            });
        }

        if (formData.property && formData.property !== 'any') {
            filteredProperties = filteredProperties.filter((item) =>
                item.ltg_type === formData.property
            );
        }

        if (formData.price && (formData.price.min !== undefined || formData.price.max !== undefined)) {
            const minPrice = formData.price.min !== undefined ? formData.price.min : "";
            const maxPrice = formData.price.max !== undefined ? formData.price.max : "";

            filteredProperties = filteredProperties.filter((item) => {
                let salePrice = parseInt(getSalePrice(item), 10);
                return (
                    (minPrice === "" || salePrice >= minPrice) &&
                    (maxPrice === "" || salePrice <= maxPrice)
                );
            });
        }

        if (formData.area && (formData.area.min !== undefined || formData.area.max !== undefined)) {
            const minArea = formData.area.min !== undefined ? formData.area.min : "";
            const maxArea = formData.area.max !== undefined ? formData.area.max : "";

            filteredProperties = filteredProperties.filter((item) => {
                const area = parseInt(getArea(item), 10);
                return (
                    (minArea === "" || area >= minArea) &&
                    (maxArea === "" || area <= maxArea)
                );
            });
        }

        if (formData.bedRooms) {
            filteredProperties = filteredProperties.filter((item) => {
                const bedrooms = parseInt(getBedrooms(item), 10);
                return bedrooms >= parseInt(formData.bedRooms, 10);
            });
        }

        if (formData.bathRooms) {
            filteredProperties = filteredProperties.filter((item) => {
                const bathrooms = parseInt(getBathrooms(item), 10);
                return bathrooms >= parseInt(formData.bathRooms, 10);
            });
        }

        if (formData.status && formData.status !== 'any') {
            filteredProperties = filteredProperties.filter((item) => {
                const status = getStatus(item);
                return status?.toLowerCase() === formData.status?.toLowerCase();
            });
        }

        if (formData.amenities && formData.amenities.length > 0) {
            filteredProperties = filteredProperties.filter((item) => {
                const amenities = getAmenities(item);
                return formData.amenities.every((amenity) => amenities.includes(amenity));
            });
        }

        setAllProperties(filteredProperties);
    };

    const getSalePrice = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_sale_price;
            case "PentHouses":
                return item.ltg_det_penthouses_sale_price;
            case "RowHouses":
                return item.ltg_det_row_house_sale_price;
            case "Plots":
                return item.ltg_det_plot_sale_price;
            case "Villaments":
                return item.ltg_det_villaments_sale_price;
            default:
                return item.ltg_det_sale_price;
        }
    };

    const getArea = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "RowHouses":
                return item.ltg_det_row_house_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "Plots":
                return item.ltg_det_plot_pmts_area_dts?.match(/(\d+)/)?.[0];
            case "Villaments":
                return item.ltg_det_villaments_pmts_area_dts?.match(/(\d+)/)?.[0];
            default:
                return item.ltg_det_pmts_area_dts?.match(/(\d+)/)?.[0];
        }
    };

    const getBedrooms = (item) => {
        switch (item.ltg_type) {
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_bed_rooms;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_bed_rooms;
            case "Villaments":
                return item.ltg_det_villaments_pmts_bed_rooms;
            default:
                return item.ltg_det_pmts_bed_rom;
        }
    };

    const getBathrooms = (item) => {
        switch (item.ltg_type) {
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_bath_rooms;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_bath_rooms;
            case "Villaments":
                return item.ltg_det_villaments_pmts_bath_rooms;
            default:
                return item.ltg_det_pmts_bth_rom;
        }
    };

    const getStatus = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_pmts_status;
            case "PentHouses":
                return item.ltg_det_penthouses_pmts_status;
            case "RowHouses":
                return item.ltg_det_row_house_pmts_status;
            case "Plots":
                return item.ltg_det_plot_pmts_status;
            case "Villaments":
                return item.ltg_det_villaments_pmts_status;
            default:
                return item.ltg_det_pmts_status;
        }
    };

    const getAmenities = (item) => {
        switch (item.ltg_type) {
            case "CommercialProperties":
                return item.ltg_det_comm_prop_amenities?.split(', ').map((amenity) => amenity.trim());
            case "PentHouses":
                return item.ltg_det_penthouses_amenities?.split(', ').map((amenity) => amenity.trim());
            case "RowHouses":
                return item.ltg_det_row_house_amenities?.split(', ').map((amenity) => amenity.trim());
            case "Plots":
                return item.ltg_det_plot_amenities?.split(', ').map((amenity) => amenity.trim());
            case "Villaments":
                return item.ltg_det_villaments_amenities?.split(', ').map((amenity) => amenity.trim());
            default:
                return item.ltg_det_amenities?.split(', ').map((amenity) => amenity.trim());
        }
    };

    useEffect(() => {
        fetchAllProperties(query);
    }, []);

    // useEffect(() => {
    //     handleFilterChange(query);
    // }, [originalProperties, query]);

  //  console.log("allProperties____",allProperties);
  const handleSelectProperty = (propertyId) => {
  setSelectedProperties((prevSelected) => {
    if (prevSelected.includes(propertyId)) {
      return prevSelected.filter((id) => id !== propertyId);
    } else {
      return [...prevSelected, propertyId];
    }
  });
};

const formatPrice = (num) => {
  if (!num || isNaN(num)) return "Price not available";

  const value = Number(num);

  if (value >= 10000000) { 
    // Crore
    return (value / 10000000).toFixed(2) + " Cr";
  } else if (value >= 100000) { 
    // Lakh
    return (value / 100000).toFixed(2) + " Lakh";
  } else if (value >= 1000) { 
    // Thousand
    return (value / 1000).toFixed(2) + " Thousand";
  } else {
    return value.toFixed(2);
  }
};


const handleShareWhatsApp = () => {
  const selectedItems = allProperties.filter((item) =>
    selectedProperties.includes(item.RowID)
  );

//console.log("selectedItems___",selectedItems);

  let message = "🏡 *Check out these properties:*\n\n";

  selectedItems.forEach((item, index) => {
    const projectName = item.ltg_projectName || "Project Name";
    const title = item.ltg_title || "Title";
   // const price = item.ltg_det_plot_sale_price || item.ltg_det_sale_price || item.ltg_det_call_for_price || "Price not available";
    const rawPrice = item.ltg_det_plot_sale_price || item.ltg_det_sale_price || item.ltg_det_call_for_price;
    const price = formatPrice(rawPrice);

    const location =
      item.ltg_det_plot_location || item.ltg_det_location || "Location not available";
      const cleanedPath = item.propertyUrl?.startsWith("/") 
  ? item.propertyUrl.slice(1) 
  : item.propertyUrl;

  const url = cleanedPath 
  ? `${window.location.origin}/Property/${cleanedPath}` 
  : window.location.href;

    message += `*${index + 1}. ${projectName}*\n`;
    message += `${title}\n`;
    message += `💰 Price: ${price}\n`;
    message += `📍 Location: ${location}\n`;
    message += `🔗 Link: ${url}\n\n`;
  });

  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
  window.open(whatsappUrl, "_blank");
};


// const handleShareWhatsApp = () => {
//   const selectedItems = allProperties.filter((item) =>
//     selectedProperties.includes(item.RowID)
//   );
// console.log("Selected Items for WhatsApp:", selectedItems);
// let message = "Check out these properties:\n\n";
// selectedItems.forEach((item, index) => {
//     const projectName = item.ltg_projectName || "Property Name";
//     const projectTitle = item.ltg_title || "Property Title";
//     const propertyUrl = item.propertyUrl || "";
//     const fullUrl = window.location.href + propertyUrl;

//     message += `*${index + 1}. ${projectName}*\n${projectTitle}\n${fullUrl}\n\n`;
//   });

//       const encodedMessage = encodeURIComponent(message);
//       const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
//       window.open(whatsappUrl, "_blank");
// };

    return (
        <>
            <Container>
                {/* <SearchForm
                    onFilterChange={handleFilterChange}
                    query={query}
                /> */}
                <div style={{ marginTop: "30px",marginBottom: "10px" }}>
                 <AdvancedSearch
                    propertyTypes={["Apartments", "Villas", "Plots", "Row Houses", "Villaments", "Commercial Properties", "Pent Houses"]}
                    budgets={[5, 10, 20, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000, 1500, 2000]}
                     onSearch={handleAdvanceSearch}
                     defaultValues={query2}
                />
               
                 <PropertyMapss 
                 properties={allProperties} 
                  center={center}
                  zoom={12}
                 options={{
                    fullscreenControl: true,
                    mapTypeControl: false,
                    streetViewControl: false,
                    zoomControl: true,
                }}
                />
                </div>
                {selectedProperties.length > 0 && (
                    <div style={{ margin: "5px 0" ,textAlign:"right"}}>
                        <button
                        variant="contained"
                        color="success"
                        
                        onClick={handleShareWhatsApp}
                        >
                        Share via WhatsApp ({selectedProperties.length})
                        </button>
                    </div>
                    )}

                {loading ? <Loader /> : (
                    allProperties.map((item) => (
                        <Card key={item.id} item={item} 
                         isSelected={selectedProperties.includes(item.RowID)}
                         onSelect={handleSelectProperty}
                        />
                    ))
                )}
            </Container>

            <section className="footerPatner  bg-[#1C1C1E] ">
                <Container
                    className={
                        "md:py-20 flex flex-col md:flex-row items-center justify-between"
                    }
                >
                    <div className="w-full left md:w-1/2 md:pr-10">
                        <h2 className="mb-4 text-4xl font-bold text-white md:text-5xl">
                            More than 10 Years of Experience
                        </h2>
                        <hr className="w-20 h-1 mb-4 bg-blue-800" />
                        <p className="text-white">
                            It’s not what we do, but how we do it that sets us apart. Get in
                            touch with us today to experience our holistic services that will
                            put you a step closer to your dream home.
                        </p>
                    </div>
                    <div className="grid w-full grid-cols-1 mt-10 right md:w-1/2 md:grid-cols-2 gap-7 md:mt-0">
                        <div className="flex items-center gap-5 1">
                            <FaSellsy className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">3500 +</h2>
                                <p className="text-white description">Properties Sold</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 2">
                            <MdAddHome className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">230 +</h2>
                                <p className="text-white description">Projects Handled</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 3">
                            <IoMdHappy className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">400 +</h2>
                                <p className="text-white description">NRI Clients Served</p>
                            </div>
                        </div>
                        <div className="flex items-center gap-5 3">
                            <FaRegHandshake className="text-blue-700" size={42} />
                            <div>
                                <h2 className="text-white price">40 +</h2>
                                <p className="text-white description">Builders, Marketing Partners</p>
                            </div>
                        </div>
                    </div>
                </Container>

                <hr className="" />
            </section>
            <Social />
        </>
    );
}

export default PropertyQuery;
